import React from 'react';
import { Button, ButtonProps } from 'reactstrap';
import XSVG from './svg/XSVG';
import classnames from 'classnames';
import { WithTestIdOptional } from 'shared-client/types/test';

interface CircleButtonProps extends ButtonProps, WithTestIdOptional {
	icon?: React.ReactNode;
	label?: string;
	iconSize?: 'sm' | 'md';
}

/**
 * Displays an SVG inside a circular button.
 * @param props
 */
function CircleButton(props: CircleButtonProps) {
	// eslint-disable-next-line no-unused-vars
	const { icon, label = 'Remove', className = '', testId, iconSize = 'sm', ...rest } = props;
	const iconSizeClass = `circle-button--icon-${iconSize}`;

	return (
		<Button
			data-testId={testId}
			className={classnames('circle-button', iconSizeClass, { [className]: className })}
			{...rest}
		>
			{props.icon ? props.icon : <XSVG class="circle-button__icon" />}
			<span className="visually-hidden">{label}</span>
		</Button>
	);
}

export default CircleButton;
